const storage = {
  STORAGE_USER_DATA: 'userData',
  STORAGE_IS_NEW_USER: 'isNewUser',
};

export default storage;
